import { ListItemIcon } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LandingImageContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexGrow: 1,
});

export const LandingContent = styled("div")({
  flexGrow: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "var(--space-2xl)",
  flexWrap: "wrap",
});

export const LandingInfoContainer = styled("div")({
  display: "flex",
  justifyContent: "flex-start",
  padding: "var(--space-2xl)",
  gap: "var(--space-smx)",
  flexDirection: "column",
  width: "100%",
  maxWidth: "30rem",
});

export const LandingInfoHeader = styled("div")({
  display: "flex",
  gap: "var(--space-2xl)",
  flexDirection: "column",

  "& h4": {
    color: "var(--color-text-primary)",
    fontWeight: "var(--font-weight-bold)",
  },

  "& h5": {
    color: "var(--color-text-primary)",
    fontWeight: "var(--font-weight-bold)",
  },
});

export const ItemIcon = styled(ListItemIcon)({
  minWidth: 0,
  marginRight: "var(--space-lg)",
  color: "var(--color-primary)",
});

export const ItemText = styled("span")({
  fontSize: "var(--font-size-lg)",
  color: "var(--color-text-primary)",
});
